import { library } from "@fortawesome/fontawesome-svg-core";

/* import specific icons */
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";

library.add(faCircleNotch);
